import { Select, SelectProps } from '@ets/design-system';
import { SelectOption } from './AdvancedFilterOptions';

export const PortalSelect = (props: Omit<SelectProps<SelectOption>, 'variant' | 'size'>) => {
  return <Select {...props} useBodyAsPortal variant="standard" isClearable={false} size="m" />;
};
